/* ============================================================================
   VITRINA — lo que ve el cliente al abrir el enlace de WhatsApp
   ---------------------------------------------------------------------------
   Pagina publica: el cliente no inicia sesion. Por eso NO consulta ninguna
   tabla, solo tres funciones que reciben el codigo del enlace y devuelven lo
   de esa vitrina. Un enlace reenviado no da acceso al catalogo ni a la lista
   de precios, solo a esa seleccion, y deja de servir al caducar.

   Los precios tampoco se mandan al enviar: el servidor los toma de lo que se
   guardo al crear la vitrina. Si no, bastaria con editar el navegador.
============================================================================ */

(function () {
  'use strict';

  var SB  = 'https://sutnfihpmfsejdlkghjp.supabase.co';
  var KEY = 'sb_publishable_5ZJdu4hX49XRH1q0dCFsAQ_0S0Eps95';

  var CODIGO = (function () {
    // Admite /pages/vitrina?v=abc123 y tambien /pages/vitrina/abc123
    var p = new URLSearchParams(location.search);
    var v = p.get('v') || p.get('codigo');
    if (v) return v.trim();
    var partes = location.pathname.split('/').filter(Boolean);
    return (partes[partes.length - 1] || '').trim();
  })();

  var PIN = null, DATOS = null, CANT = {};

  function rpc(fn, args) {
    return fetch(SB + '/rest/v1/rpc/' + fn, {
      method: 'POST',
      headers: { 'apikey': KEY, 'Authorization': 'Bearer ' + KEY,
                 'Content-Type': 'application/json' },
      body: JSON.stringify(args || {})
    }).then(function (r) { return r.json(); });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function dinero(v) {
    return '$' + (Number(v) || 0).toLocaleString('en-US',
      { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function num(v) { return (Number(v) || 0).toLocaleString('en-US'); }
  function $(id) { return document.getElementById(id); }

  // ── Arranque ──────────────────────────────────────────────────────────────
  function abrir() {
    if (!CODIGO) return aviso('Enlace incompleto',
      'Pidele a tu vendedor que te lo reenvie.');
    rpc('vitrina_abrir', { p_codigo: CODIGO, p_pin: PIN }).then(function (d) {
      if (!d || d.ok !== true) return problema(d);
      DATOS = d;
      pintar();
    }).catch(function () {
      aviso('No se pudo abrir', 'Revisa tu conexion e intentalo de nuevo.');
    });
  }

  function problema(d) {
    var m = d && d.motivo;
    if (m === 'pin') return pedirPin();
    if (m === 'vencida') {
      return aviso('Esta seleccion ya vencio',
        'Escribele a tu vendedor y te manda una nueva.');
    }
    if (m === 'ya_enviada') {
      return aviso('Pedido recibido',
        'Ya nos enviaste este pedido. Tu vendedor se comunicara contigo.');
    }
    aviso('No encontramos esta seleccion',
      'Puede que el enlace este incompleto. Pidele a tu vendedor que te lo reenvie.');
  }

  function pedirPin() {
    $('v-tit').textContent = 'Codigo de acceso';
    $('v-sub').textContent = '';
    $('v-items').innerHTML =
      '<div class="aviso"><h2>Escribe el codigo</h2>' +
      '<p>Es el que te dicto tu vendedor.</p>' +
      '<div class="pin"><input id="v-pin" inputmode="numeric" maxlength="8" ' +
      'autocomplete="off"></div>' +
      '<div style="margin-top:14px"><button class="enviar" id="v-pin-ok">Entrar</button></div>' +
      '</div>';
    $('v-pin-ok').onclick = function () {
      PIN = ($('v-pin').value || '').trim();
      if (!PIN) return;
      $('v-items').innerHTML = '';
      $('v-tit').textContent = 'Abriendo\u2026';
      abrir();
    };
    $('v-pin').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') $('v-pin-ok').click();
    });
  }

  function aviso(t, p) {
    $('v-tit').textContent = 'Kennedy Center';
    $('v-sub').textContent = '';
    $('v-saludo').innerHTML = '';
    $('v-pie').style.display = 'none';
    $('v-items').innerHTML =
      '<div class="aviso"><h2>' + esc(t) + '</h2><p>' + esc(p) + '</p></div>';
  }

  // ── La vitrina ────────────────────────────────────────────────────────────
  function pintar() {
    $('v-tit').textContent = DATOS.titulo || 'Cotizaci\u00f3n';

    var dias = Math.max(0, Math.ceil(
      (new Date(DATOS.vence) - new Date()) / 86400000));
    $('v-sub').textContent =
      (DATOS.vendedor ? ('Tu vendedor: ' + DATOS.vendedor + ' \u00b7 ') : '') +
      (dias <= 1 ? 'vence hoy' : 'vence en ' + dias + ' dias');

    $('v-saludo').innerHTML = DATOS.mensaje
      ? '<div class="saludo">' + esc(DATOS.mensaje) + '</div>' : '';

    var h = '';
    (DATOS.items || []).forEach(function (it, i) {
      var disp = Number(it.disponible) || 0;
      var agotado = disp <= 0;
      var b = Math.max(1, Number(it.bulto) || 1);

      // La cantidad que dejo puesta el vendedor. Es una propuesta: el cliente
      // la sube, la baja o la quita.
      var sug = Math.min(Math.max(0, Number(it.cantidad) || 0), disp);
      CANT[i] = sug;

      var f = it.ficha || {};
      // El mismo orden y las mismas etiquetas del informe de recepcion.
      var filas = [
        ['Descripci\u00f3n',    it.nombre],
        ['',                     it.ingles],
        ['Composici\u00f3n',    f.composicion],
        ['Colores',              f.colores],
        ['Tama\u00f1o x Pza',   f.tamano],
        ['Peso x Bulto',         f.peso],
        ['Cubicaje x Bulto',     f.cubicaje],
        ['Empaque',              f.empaque],
        ['Marca',                f.marca],
        ['Origen',               f.origen],
        ['C\u00f3digo de barra', f.barra]
      ].filter(function (r) { return r[1]; });

      h += '<div class="it" data-i="' + i + '">' +

        '<div class="foto">' +
          (it.foto
            ? '<img src="' + esc(it.foto) + '" alt="" loading="lazy">'
            : '<div class="sinfoto"></div>') +
          '<div class="sku">' + esc(it.itemcode) + '</div>' +
        '</div>' +

        '<div class="datos">' +
          filas.map(function (r) {
            return '<div class="fila"><span class="et">' + esc(r[0]) + '</span>' +
                   '<span class="va">' + esc(r[1]) + '</span></div>';
          }).join('') +
        '</div>' +

        '<div class="caja">' +
          '<div class="cab2"><span>Cantidad</span><span>Precio</span></div>' +
          '<div class="cue">' +
            '<div class="cant">' +
              (agotado
                ? '<div class="ago">Agotado</div>'
                : ('<div class="qty">' +
                     '<button data-m="-1" data-i="' + i + '" aria-label="Quitar">\u2212</button>' +
                     '<input id="q' + i + '" type="number" inputmode="numeric" min="0" ' +
                            'max="' + disp + '" value="' + sug + '" data-i="' + i + '">' +
                     '<button data-m="1" data-i="' + i + '" aria-label="Agregar">+</button>' +
                   '</div>' +
                   '<div class="sub" id="b' + i + '"></div>')) +
            '</div>' +
            '<div class="prec">' + dinero(it.precio) +
              (it.lista ? '<div class="ant">' + dinero(it.lista) + '</div>' : '') +
              (b > 1 ? '<div class="xb">' + dinero(it.precio * b) + ' / bulto</div>' : '') +
            '</div>' +
          '</div>' +
          '<div class="lin" id="L' + i + '"></div>' +
          (agotado ? '' : '<div class="dsp">' + num(disp) + ' disponibles</div>') +
        '</div>' +

      '</div>';
    });
    $('v-items').innerHTML = h;
    $('v-pie').style.display = 'block';

    // Un solo oyente para toda la lista: con cincuenta productos, cincuenta
    // oyentes sobran.
    $('v-items').addEventListener('click', function (e) {
      var b = e.target.closest('button[data-m]');
      if (!b) return;
      mover(+b.dataset.i, +b.dataset.m);
    });
    $('v-items').addEventListener('change', function (e) {
      if (e.target.tagName === 'INPUT') fijar(+e.target.dataset.i, e.target.value);
    });

    $('v-env').onclick = enviar;
    (DATOS.items || []).forEach(function (it, i) { pintarLinea(i); });
    total();
    verVisibles();
  }

  function tope(i) { return Number((DATOS.items[i] || {}).disponible) || 0; }

  // Lo que suma esa linea con la cantidad que puso el cliente.
  function pintarLinea(i) {
    var it = DATOS.items[i] || {};
    var b = Math.max(1, Number(it.bulto) || 1);
    var c = CANT[i] || 0;
    var eb = $('b' + i);
    if (eb) eb.textContent = (b > 1 && c) ? (Math.round(c / b * 100) / 100) + ' bultos' : '';
    var el = $('L' + i);
    if (el) el.textContent = c ? dinero(c * (Number(it.precio) || 0)) : '';
  }

  function mover(i, signo) {
    var b = Math.max(1, Number(DATOS.items[i].bulto) || 1);
    fijar(i, (CANT[i] || 0) + signo * b);
  }

  function fijar(i, v) {
    v = Math.max(0, Math.min(tope(i), Math.floor(Number(v) || 0)));
    var antes = CANT[i] || 0;
    CANT[i] = v;
    var inp = $('q' + i);
    if (inp) inp.value = v;
    pintarLinea(i);
    total();
    if (v !== antes) {
      rpc('vitrina_evento', { p_codigo: CODIGO, p_tipo: v > antes ? 'agregar' : 'quitar',
                              p_itemcode: DATOS.items[i].itemcode, p_cantidad: v })
        .catch(function () {});
    }
  }

  function total() {
    var pzs = 0, blt = 0, t = 0, refs = 0;
    Object.keys(CANT).forEach(function (i) {
      var c = CANT[i] || 0;
      if (!c) return;
      var it = DATOS.items[i];
      var b = Math.max(1, Number(it.bulto) || 1);
      refs += 1;
      pzs  += c;
      blt  += c / b;
      t    += c * (Number(it.precio) || 0);
    });
    // Tres medidas, porque las tres se usan: las piezas para el cliente, los
    // bultos para el flete y el total para decidir.
    $('v-pzs').textContent =
      num(refs) + (refs === 1 ? ' art\u00edculo' : ' art\u00edculos') + ' \u00b7 ' +
      num(pzs)  + (pzs === 1 ? ' pieza' : ' piezas') + ' \u00b7 ' +
      (Math.round(blt * 100) / 100) + (blt === 1 ? ' bulto' : ' bultos');
    $('v-tot').textContent = dinero(t);
    $('v-env').disabled = pzs === 0;
  }

  // Que miro y no pidio: es el dato que hoy no tiene nadie.
  function verVisibles() {
    if (!('IntersectionObserver' in window)) return;
    var vistos = {};
    var ob = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = e.target.dataset.i;
        if (vistos[i]) return;
        vistos[i] = 1;
        rpc('vitrina_evento', { p_codigo: CODIGO, p_tipo: 'ver',
                                p_itemcode: DATOS.items[i].itemcode })
          .catch(function () {});
      });
    }, { threshold: 0.6 });
    Array.prototype.forEach.call(
      document.querySelectorAll('.it'), function (el) { ob.observe(el); });
  }

  // ── Enviar ────────────────────────────────────────────────────────────────
  function enviar() {
    var lineas = [];
    Object.keys(CANT).forEach(function (i) {
      if (CANT[i] > 0) lineas.push({ itemcode: DATOS.items[i].itemcode,
                                     cantidad: CANT[i] });
    });
    if (!lineas.length) return;

    var b = $('v-env');
    b.disabled = true;
    b.textContent = 'Enviando\u2026';

    rpc('vitrina_enviar', { p_codigo: CODIGO, p_lineas: lineas, p_pin: PIN })
      .then(function (d) {
        if (d && d.ok === true) {
          $('v-pie').style.display = 'none';
          $('v-saludo').innerHTML = '';
          $('v-items').innerHTML =
            '<div class="aviso"><h2>Pedido enviado</h2>' +
            '<p>' + (d.vendedor ? esc(d.vendedor) : 'Tu vendedor') +
            ' lo recibio y se comunicara contigo para confirmarlo.</p>' +
            '<p style="margin-top:10px;font-weight:700;color:var(--tinta)">' +
            dinero(d.total) + '</p></div>';
          window.scrollTo(0, 0);
          return;
        }
        b.disabled = false;
        b.textContent = 'Confirmar pedido';
        if (d && d.motivo === 'ya_enviada') {
          aviso('Ya lo habiamos recibido',
                'Tu vendedor se comunicara contigo.');
        } else if (d && d.motivo === 'vencida') {
          aviso('Esta seleccion ya vencio',
                'Escribele a tu vendedor y te manda una nueva.');
        } else {
          // Se muestra el motivo real. Un "intentalo de nuevo" generico deja
          // al cliente atascado y al vendedor sin saber que paso.
          alert('No se pudo enviar.' +
                (d && d.motivo ? ('\n\nMotivo: ' + d.motivo) : '') +
                '\n\nEscribele a tu vendedor.');
          try{ console.error('[vitrina] enviar:', d); }catch(_){}
        }
      })
      .catch(function () {
        b.disabled = false;
        b.textContent = 'Confirmar pedido';
        alert('No se pudo enviar. Revisa tu conexion.');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', abrir);
  } else {
    abrir();
  }
})();
